import React from "react";
import "./FeedbackSubmitted.scss";
import { ReactComponent as ThankYouIcon } from "../../../../assets/icons/Feedback_Submitted.svg";

//Content to be shown when user feedback has been submitted successfully.
const FeedbackSubmitted = ({ onClose }) => {
  return (
    <div className="feedback-form form-submitted">
      <i className="form-submitted__icon">
        <ThankYouIcon />
      </i>
      <h4 className="form-submitted__title">Thank you for contacting us.</h4>
      <p className="form-submitted__message">
        Your query has been received by the Vendify team, we will contact you
        soon for the same.
      </p>
      <button className="form-submitted__btn" onClick={onClose}>
        OK
      </button>
    </div>
  );
};

export default FeedbackSubmitted;
